/**
 * Les mesures de `<LiveTandemBubble>`, la miniature du duo Sam + masteur. Pures : elles se lisent sous
 * Jest. La scène du live en fait son duo en grand (`organisms/LiveStage/stageLayout.ts`), et la bascule de
 * la visio vise son visage de devant quand elle n'a pas pu le mesurer (`pages/StudentLivePage/stageMorph.ts`).
 *
 * La perspective (Wajih, 22/10) : le visage de devant au bas gauche de la boîte, celui de derrière en
 * retrait vers le haut et la droite, **légèrement superposé** au premier — la même superposition, à
 * toutes les tailles.
 */
import { SAM_TILE_SIZE } from "../../molecules/SamTile/samTileGeometry"

/** Le visage de devant : il tient dans la hauteur réservée à une tuile de Sam, recul compris. */
export const TANDEM_FACE = 56
/** Le visage de derrière remonte de ce que la tuile de Sam a de plus que lui. */
export const TANDEM_BACK_SHIFT_Y = -(SAM_TILE_SIZE - TANDEM_FACE)
/** Sam derrière le masteur (le Dialogue) : son recul vers la droite. */
export const TANDEM_SAM_BACK_SHIFT_X = 34
/** Le masteur derrière Sam (le Concentré, l'attente) : plus décalé, pour rester visible. */
export const TANDEM_TUTOR_BACK_SHIFT_X = 40
/** Le masteur derrière Sam garde la taille de Sam (Wajih, 20/10 : plus petit, sa vidéo ne se lisait pas). */
export const TANDEM_TUTOR_BACK_SCALE = 1
/** La boîte de la bulle avec Sam : le visage de devant, plus le recul de celui de derrière. */
export const TANDEM_BOX_WIDTH = TANDEM_FACE + Math.max(TANDEM_SAM_BACK_SHIFT_X, TANDEM_TUTOR_BACK_SHIFT_X)
/** Le centre du visage de devant, depuis le bord droit de la boîte. */
export const TANDEM_FRONT_FROM_RIGHT = TANDEM_BOX_WIDTH - TANDEM_FACE / 2
